import script from "./activeBonusView.vue?vue&type=script&setup=true&lang=ts"
export * from "./activeBonusView.vue?vue&type=script&setup=true&lang=ts"

import "./activeBonusView.vue?vue&type=style&index=0&id=917b1898&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917b1898"]])

export default __exports__